
import 'core-js'
import { IframeRemoteCall } from "@commonUtils/IframeRemoteCall"
import { ajaxPost } from '/app/tinyProj/common/request.js'

let urlSearch = location.search

let optionPost = {"type":"GROUP_REQUEST_READ","object":{},"params":[{"name":"OUTPUT_FILTER_STRING","string_value":"/group/tags"},{"name":"OUTPUT_FILTER_STRING","string_value":"/group/group_caps"},{"name":"OUTPUT_FILTER_STRING","string_value":"/group/local"},{"name":"OUTPUT_FILTER_STRING","string_value":"/group/integrations"},{"name":"OUTPUT_FILTER_STRING","string_value":"/group/partner"},{"name":"OUTPUT_FILTER_STRING","string_value":"/group/roles"},{"name":"OUTPUT_FILTER_STRING","string_value":"/group/routing_config"}]}
if (urlSearch.indexOf('type=acdsdk') >= 0 || window.location.href.indexOf('type=acdsdk') >= 0) {
  //it is actually cardsdk, but we will keep this as it is already being used
  import('./index.js')
} else {
  ajaxPost( '/board', optionPost, (res)=>{
    const webVersion = res.object.group?.web_version
    const { pathname,href } = window.location
    let matchedPath = pathname && pathname.split('/')
    const domainList = href.split(pathname)
    if(webVersion && webVersion !== 'web' && matchedPath[matchedPath.length - 2] ==='web'){
      matchedPath[matchedPath.length - 2] = `web/${webVersion}`
      window.location.href = domainList[0]+ matchedPath.join('/') + domainList[1]
    }else{
      // pathname: /web/webversion/XXX
      let currentWebversion = matchedPath[2] ? matchedPath[2] : matchedPath[1]
      let WebVersionInSetting = webVersion || 'web'
      if( matchedPath[1] === 'web' && currentWebversion && WebVersionInSetting && WebVersionInSetting !== currentWebversion){
        if(WebVersionInSetting === 'web'){
          matchedPath.splice(2, 1)
        }else{
          matchedPath[2] = WebVersionInSetting
        }
        window.location.href = domainList[0]+ matchedPath.join('/') + domainList[1]
      }else{
        import('./index.js').then(_ => {
          appDocumentReady()
        })
      }
    }
  },(err)=>{
    import('./index.js').then(_ => {
      appDocumentReady()
    })
  })
}
const appDocumentReady = () => {
  const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
  }
  if (inIframe()) {
    const irc = new IframeRemoteCall(window, window.parent)
    irc.call('app_ready')
  }
}
